import { render, staticRenderFns } from "./AccountRecovery.vue?vue&type=template&id=3b421ec4&scoped=true"
import script from "./AccountRecovery.vue?vue&type=script&lang=js"
export * from "./AccountRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b421ec4",
  null
  
)

export default component.exports